import { padStart, random } from 'lodash'

import { Token } from '@revolut-internal/ui-kit'

const COLOR_FOR_INDEX = [
  Token.color.blue,
  Token.color.red,
  Token.color.green,
  Token.color.pink,
  Token.color.deepPink,
  Token.color.deepPurple,
  Token.color.yellow,
  Token.color.lightGreen,
  Token.color.purple,
  Token.color.deepGrey,
]

const generateRandomHexColor = () =>
  `#${padStart(random(0x000000, 0xffffff).toString(16), 6, '0')}`

const colors = Array.from({ length: 1000 }).reduce<Record<number, string>>(
  (acc, _, index) => {
    acc[index] = COLOR_FOR_INDEX[index] ?? generateRandomHexColor()

    return acc
  },
  {},
)

export const getColorByIndex = (index: number, shift = 0) => colors[index + shift]
